import { useQueryClient } from '@tanstack/react-query';
import { emptyFunction } from '@/functions';

const useInvalidateQueries = () => {

  const queryClient = useQueryClient();

  /**
   * Invalidate all queries that start with keys.
   * @param queryKey Keys of queries to invalidate.
   */
  const invalidate = (...queryKey: any[]) =>
    queryClient
      .invalidateQueries({ queryKey, exact: false })
      .catch(emptyFunction);

  /**
   * Invalidate all queries that match exactly keys.
   * @param queryKey Keys of queries to invalidate.
   */
  const invalidateExact = (...queryKey: any[]) =>
    queryClient
      .invalidateQueries({ queryKey, exact: true })
      .catch(emptyFunction);

  return ({
    invalidateExact,
    invalidate
  });

};

export default useInvalidateQueries;
